import * as yup from "yup"
import { getAge } from "../../../../utils/dates"
import { isValidPassword } from "../../services/pwdService"

export const registrationSchema = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  password: yup
    .string()
    .required()
    .test("pwd-strength", "", (value: string) => isValidPassword(value)),
  email: yup.string().email().required(),
  gender: yup.string(),
  // tos: yup
  //   .boolean()
  //   .required()
  //   .test("tosAccepted", "", (value: boolean) => value),
  marketing: yup.boolean(),
  profiling: yup.boolean(),
  survey: yup.boolean(),
  card: yup.boolean(),
  birthday: yup
    .date()
    .test(
      "age-check",
      "Devi avere almeno 18 anni per registrarti",
      (value) => value !== undefined && getAge(value) >= 18
    ),
})
